module.exports = __webpack_public_path__ + "static/collectorcans-del-artwork-e0c3676073cc7fc25e45113eec0dad1f.png";